import { Injectable } from '@angular/core';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class WithdrawalCommandsService {

  constructor(private commonService: CommonService) { }

  async fetchWithdrawalCommands() {
    return await this.commonService.getSimpleList(`withdrawal_command`);
  }

  async fetchWithdrawalCommand(recordId: number) {
    return await this.commonService.getSimpleList(`withdrawal_command/${recordId}`);
  }
}
